import { createBrowserRouter, Navigate, RouteObject } from 'react-router-dom';

// AUTH PAGES
import AuthLayout from 'components/layout/AuthLayout';
import LoginPage from 'pages/auth/login/Login';
import SignUpPage from 'pages/auth/sign-up';
import ForgotPassword from 'pages/auth/forgot-password/ForgotPassword';
import ForgotPasswordOTPPage from 'pages/auth/forgot-password/ForgotPasswordOTP';

// DASHBOARD PAGES
import DashboardPage from 'pages/dashboard';
import MainLayout from 'components/layout/MainLayout';
import FaceScanReportPage from 'pages/face-scan/report';
import StartScan from 'pages/face-scan/scan';
import InterpretLabReportPage from 'pages/interpret-lab-report';
import PersonlisedAIReportPage from 'pages/personalised-ai-report';
import GeneratePersonalisedAIReportPage from 'pages/personalised-ai-report/generate';
import GenerateLabReportPage from 'pages/interpret-lab-report/generate';
import HelpDeskTicketPage from 'pages/help-desk-ticket';
import HelpDeskTicketDetailsPage from 'pages/help-desk-ticket/ticket-details';
import ProfilePage from 'pages/profile';
import AddNewMember from 'pages/add-member';
import SendFeedbackPage from 'pages/feedback';
import AddHelpDeskTicketPage from 'pages/help-desk-ticket/add-ticket';
import FaceScanResultPage from 'pages/face-scan/scan-result';
import CommunicationPreferencePage from 'pages/communication-preference/page';

import { PATH_ROUTES } from './path';
import { DISABLED_PATHS } from 'lib/feature-flags';
import MobileQrFaceScan from 'pages/face-scan/mobile-qr-scan';
import SignUpVerificationPage from 'pages/auth/sign-up/SignUpVerification';
import VoiceScanPage from 'pages/voice-scan/report';
import SymptomCheckerPage from 'pages/symptom-checker/report';
import StartVoiceScanPage from 'pages/voice-scan/scan';
import VoiceScanDetail from 'pages/voice-scan/details';
import QuestionnairePage from 'pages/profile/questionnaire/components/Questionnaire';
import GenerateSymptomCheckerPage from 'pages/symptom-checker/generate';
import SymptomCheckerReview from 'pages/symptom-checker/generate/Review';
import SymptomCheckerGenerating from 'pages/symptom-checker/generate/Generating';
import NotificationPage from 'pages/notification';
import NotificationDetail from 'pages/notification/details';
import RiskCheckerPage from 'pages/risk-checker';
import RiskScanConfirmation from 'pages/risk-checker/ScanConfirmation';
import RiskDetails from 'pages/risk-checker/details';
import RiskCheckerQuestionnairePage from 'pages/risk-checker/questionnaire/Questionnaire';
import ResetPasswordPage from 'pages/auth/login/ResetPassword';
import OTPRegisterPage from 'pages/auth/login/OTPRegister';
// import HSBCCardVerificationPage from 'pages/auth/sign-up/HSBCCardVerification';

const ALL_ROUTES: RouteObject[] = [
  // AUTH ROUTES
  {
    element: <AuthLayout />,
    children: [
      { path: PATH_ROUTES.LOGIN, element: <LoginPage /> },
      { path: PATH_ROUTES.RESET_PASSWORD, element: <ResetPasswordPage /> },
      { path: PATH_ROUTES.OTP_REGISTER, element: <OTPRegisterPage /> },

      { path: PATH_ROUTES.SIGNUP, element: <SignUpPage /> },
      {
        path: PATH_ROUTES.SIGNUP_VERIFICATION,
        element: <SignUpVerificationPage />,
      },
      // {
      //   path: PATH_ROUTES.HSBC_VERIFICATION,
      //   element: <HSBCCardVerificationPage />,
      // },
      { path: PATH_ROUTES.FORGOT_PASSWORD, element: <ForgotPassword /> },
      {
        path: PATH_ROUTES.FORGOT_PASSWORD_OTP,
        element: <ForgotPasswordOTPPage />,
      },
    ],
  },

  // MOBILE QR SCAN ROUTE
  { path: PATH_ROUTES.MOBILE_QR_SCAN, element: <MobileQrFaceScan /> },

  // DASHBAORD ROUTES
  {
    element: <MainLayout />,
    children: [
      // DASHBAORD
      { path: PATH_ROUTES.DASHBOARD, element: <DashboardPage /> },

      // FACE SCAN
      { path: PATH_ROUTES.FACE_SCAN, element: <FaceScanReportPage /> },
      {
        path: PATH_ROUTES.START_FACE_SCAN,
        element: <StartScan />,
      },
      {
        path: PATH_ROUTES.FACE_SCAN_RESULT,
        element: <FaceScanResultPage />,
      },

      // VOICE SCAN
      { path: PATH_ROUTES.VOICE_SCAN, element: <VoiceScanPage /> },
      { path: PATH_ROUTES.START_VOICE_SCAN, element: <StartVoiceScanPage /> },
      { path: PATH_ROUTES.VOICE_SCAN_DETAIL, element: <VoiceScanDetail /> },

      // LAB REPORT
      {
        path: PATH_ROUTES.INTERPRET_LAB_REPORT,
        element: <InterpretLabReportPage />,
      },
      {
        path: PATH_ROUTES.GENERATE_LAB_REPORT,
        element: <GenerateLabReportPage />,
      },

      // PERSONALISED AI REPORT
      {
        path: PATH_ROUTES.PERSONALISED_AI_REPORT,
        element: <PersonlisedAIReportPage />,
      },
      {
        path: PATH_ROUTES.GENERATE_AI_REPORT,
        element: <GeneratePersonalisedAIReportPage />,
      },

      // SYMPTOM CHECKER
      {
        path: PATH_ROUTES.SYMPTOM_CHECKER,
        element: <SymptomCheckerPage />,
      },
      {
        path: PATH_ROUTES.GENERATE_SYMPTOM_CHECKER,
        element: <GenerateSymptomCheckerPage />,
      },
      {
        path: PATH_ROUTES.GENERATE_SYMPTOM_REVIEW,
        element: <SymptomCheckerReview />,
      },
      {
        path: PATH_ROUTES.GENERATE_SYMPTOM_GENERATING,
        element: <SymptomCheckerGenerating />,
      },

      // HELP DESK
      { path: PATH_ROUTES.HELP_DESK, element: <HelpDeskTicketPage /> },
      {
        path: PATH_ROUTES.HELP_DESK_CREATE,
        element: <AddHelpDeskTicketPage />,
      },
      {
        path: PATH_ROUTES.HELP_DESK_DETAILS,
        element: <HelpDeskTicketDetailsPage />,
      },

      // PROFILE
      { path: PATH_ROUTES.PROFILE, element: <ProfilePage /> },
      { path: PATH_ROUTES.ADD_MEMBER, element: <AddNewMember /> },

      { path: PATH_ROUTES.SEND_FEEDBACK, element: <SendFeedbackPage /> },

      {
        path: PATH_ROUTES.COMMUNICATION_PREFERENCE,
        element: <CommunicationPreferencePage />,
      },

      // QUESTIONNAIRE
      {
        path: PATH_ROUTES.QUESTIONNAIRE,
        element: <QuestionnairePage />,
      },

      // RISK ANALYSIS
      {
        path: PATH_ROUTES.RISK_ANALYSIS,
        element: <RiskCheckerPage />,
      },
      {
        path: PATH_ROUTES.RISK_ANALYSIS_SCAN,
        element: <RiskScanConfirmation />,
      },
      {
        path: PATH_ROUTES.RISK_ANALYSIS_DETAIL,
        element: <RiskDetails />,
      },
      {
        path: PATH_ROUTES.RISK_ANALYSIS_QUESTIONNAIRE,
        element: <RiskCheckerQuestionnairePage />,
      },

      // NOTIFICATION
      {
        path: PATH_ROUTES.NOTIFICATION,
        element: <NotificationPage />,
      },
      {
        path: PATH_ROUTES.NOTIFICATION_DETAIL,
        element: <NotificationDetail />,
      },
    ],
  },
];

const visible = (rs: RouteObject[]): RouteObject[] =>
  rs
    .filter((r) => !r.path || !DISABLED_PATHS.includes(r.path))
    .map((r) => (r.children ? { ...r, children: visible(r.children) } : r));

export const routes: RouteObject[] = visible(ALL_ROUTES).concat({
  path: '*',
  element: <Navigate to={PATH_ROUTES.DASHBOARD} replace />,
});

export const router = createBrowserRouter(routes);
